// extracted by mini-css-extract-plugin
export default {"wrap":"TechMarquee_wrap__dnWFY","track":"TechMarquee_track__GxSGW","scroll":"TechMarquee_scroll__dk51u","item":"TechMarquee_item__cKmd7","dot":"TechMarquee_dot__p0MWL"};